import { Component, OnInit, OnDestroy } from '@angular/core'
import { Observable, of } from 'rxjs'
import {
  User,
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { saveAs } from 'file-saver'
import { Router } from '@angular/router'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { QuoteCheckoutService } from '../../../quote-checkout/services/quote-checkout.service'
import { QuoteDataService } from '../../../quote-checkout/services/quote-data.service'
import { switchMap } from 'rxjs/operators'
import { QuoteReviewService } from '../../services/quote-review.service'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { BreadcrumbService } from '../../../../../shared/components/breadcrumb/breadcrumb.service'
import { CommonService } from '../../../../../shared/services/common.service'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { take } from 'rxjs/operators'

import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
  GTMCartType
} from '../../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../../shared/services/gtm.service';
import { QuoteCartFacade } from '../../../../cart/mini-cart/store/mini-quote-cart.facade';

@Component({
  standalone: false,
  selector: 'vs-quote-review',
  templateUrl: './quote-review.component.html',
  styleUrls: ['./quote-review.component.scss'],
})
export class QuoteReviewComponent implements OnInit, OnDestroy {
  isLoggedinUser = false
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  cartLoaded = false
  cartData: any
  cartData$: Observable<any>
  productData: any
  reviewData: any
  complianceQuestionData: any
  notificationEmail: any
  endCountry: any
  attachments: any
  showPrice = true
  contactNumber: any
  legalEntityData: any
  showComplienceQues: boolean
  checkQuoteType: boolean = false
  fastTrack: string
  fasttrackPriceData: any
  quoteCartLabel
  quoteCheckoutLabel

  constructor(
    private quoteCheckoutService: QuoteCheckoutService,
    private quoteService: QuoteCartService,
    private auth: AuthService,
    private router: Router,
    private quoteReviewService: QuoteReviewService,
    private breadCrumbService: BreadcrumbService,
    private globalMessageService: GlobalMessageService,
    private translate: TranslationService,
    private commonService: CommonService,
    private userAccountFacade: UserAccountFacade,
    private multiCartFacade: MultiCartFacade,
    private activeCartFacade: ActiveCartFacade,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade
  ) {}

  ngOnInit(): void {
    this.fastTrack = sessionStorage.getItem('fastTrack')
    if (this.fastTrack == 'true') this.getFastTrackPrice()
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
    this.getCheckOutCartData()

    this.translate
      .translate('quoteReview.quoteCart')
      .subscribe((res: string) => {
        this.quoteCartLabel = res
      })

    this.translate
      .translate('quoteReview.quoteCheckout')
      .subscribe((res: string) => {
        this.quoteCheckoutLabel = res
        let breadcrumb = [
          {
            label: this.quoteCartLabel,
            link: '/quote/cart',
          },
          {
            label: this.quoteCheckoutLabel,
            link: '/quote/checkout',
          },
        ]
        this.breadCrumbService.setBreadCrumbs(breadcrumb)
      })

    this.translate
      .translate('quoteReview.quoteReview')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.getLegalEntity()
  }
  getFastTrackPrice() {
    const apiParams = ['products', 'productCode']
    let lastPart = `checkPriceAndAvailability?`
    lastPart += `productCode=EXPED`
    apiParams.push(lastPart)
    const apiUrl = this.commonService.constructUrl(apiParams)
    let paylod = {
      customerRequestedDate: '',
      quantity: 1,
      selectedPlant: null,
    }
    this.commonService.postData(apiUrl, paylod).subscribe(
      (data) => {
        this.fasttrackPriceData = data
        // this.spinnerOverlayService.hide();
      },
      (error) => {
        // this.spinnerOverlayService.hide();
        this.globalMessageService.add(
          { key: 'quoteReview.unknownErrorOccured' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  getLegalEntity() {
    const legalEntity = 'legalEntity'
    this.quoteCheckoutService
      .getLegalEntity(this.userType)
      .subscribe((data: any) => {
        this.legalEntityData = data[legalEntity]
      })
  }
  getCheckOutCartData() {
    if (this.userType === 'current') {
      this.cartId = sessionStorage.getItem('cartId-current')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-current')
    }
    if (this.userType === 'anonymous') {
      this.cartId = sessionStorage.getItem('cartId-anonymous')
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-anonymous')
    }
    this.cartData$ = this.quoteService.getCart(this.cartId, this.userType)
    this.cartData$.subscribe(
      (data: any) => {
        this.cartLoaded = true
        this.cartData = data

        if (this.cartData?.entries.length == 0) {
          this.globalMessageService.add(
            { key: 'quoteReview.noEntriesFound' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
          this.router.navigate(['quote/cart'])
        }
        this.endCountry = this.cartData?.endUserAddress?.country?.isocode
        this.productData = data.entries
        this.complianceQuestionData = {
          hasRestrictedUse: this.cartData?.hasRestrictedUse,
          isNuclear: this.cartData?.isNuclear,
          restrictedCountryCheck: this.cartData?.restrictedCountryCheck,
          requiresExportLicense: this.cartData?.requiresExportLicense,
          sanctionCheck: this.cartData?.sanctionCheck,
          customerReviewCheck: this.cartData?.customerReviewCheck,
          restrictedPartList: this.cartData?.restrictedPartList,
          warningFlags: this.cartData?.warningFlags,
          governmentParties: this.cartData?.governmentParties,
        }
        for (var i = 0; i < this.cartData?.entries.length; i++) {
          if (!this.cartData?.entries[i].isCatalogItem) {
            this.showPrice = false
          }
        }
        this.showComplienceQuestions()
        this.notificationEmail = this.cartData?.notificationEmail
        this.attachments = this.cartData?.attachments
        this.contactNumber = this.cartData?.contactNumber
        let msgText = ''
        if (
          this.cartData?.isNuclear ||
          this.cartData?.restrictedCountryCheck ||
          this.cartData?.requiresExportLicense
        ) {
          if (this.cartData?.isNuclear) {
            msgText = msgText + 'quoteReview.quoteContainsNuclearParts'
          }
          if (this.cartData?.restrictedCountryCheck) {
            msgText = msgText + 'quoteReview.transactionInvolve'
          }
          if (this.cartData?.requiresExportLicense) {
            msgText = msgText + 'quoteReview.requiresLocalCountryExportLicense'
          }
          this.globalMessageService.add(
            { key: msgText },
            GlobalMessageType.MSG_TYPE_WARNING,
            30000
          )
        }

        let errorMsg = this.cartData.isEndUserIndustryNuclear
        if (this.cartData.isEndUserIndustryNuclear) {
          this.globalMessageService.add(
            { key: errorMsg },
            GlobalMessageType.MSG_TYPE_WARNING,
            10000
          )
          window.scroll(0, 0)
        }
      },
      (error) => {}
    )
  }
  downloadPDF() {
    this.quoteReviewService
      .downloadQuotePdf(this.userType, this.cartId)
      .subscribe((res) => {
        if (res !== null && res !== undefined) {
          let fileName = 'rfqreview'
          const blob = new Blob([res], { type: 'application/pdf' })
          const file = new File([blob], fileName + '.pdf', {
            type: 'application/pdf',
          })
          saveAs(file)
        } else {
          this.globalMessageService.add(
            { key: 'quoteReview.pdfNotAvailable' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
      })
  }
  sumbitQuote() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    this.quoteReviewService
      .submitQuote(this.userType, this.cartId, this.fastTrack)
      .subscribe(
        (success: any) => {
          sessionStorage.setItem('quote-code', success?.code)
          this.quoteReviewService.setCode(success?.code)
          this.gtmPurchaseEvent(success?.code);
          if (success?.code) {
            this.activeCartFacade
            .getActiveCartId()
            .pipe(take(1))
            .subscribe((res: any) => {
              if (res) {
                this.quoteCartFacade.loadCart();
              }
            })

            this.router.navigate(['quote/confirmation']);
          }
          if (!success?.code || success?.code == '' || success?.code == null) {
            this.globalMessageService.add(
              { key: 'quoteReview.errorWhileSubmittingQuoteSAP' },
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            this.getQuoteCart()
            window.scrollTo(0, 0)
            setTimeout(() => {
              this.router.navigate(['quote/cart'])
            }, 7000)
          }
        },
        (error) => {
          this.globalMessageService.add(
            { key: 'quoteReview.errorWhileSubmittingQuote' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
      )
  }

  checkForObsoleteProducts(cartData) {
    for (let entry of cartData.entries) {
      if (entry.product.obsoleteProductFlag) {
        return true
      }
    }
    return false
  }

  ngOnDestroy() {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_WARNING)
    if (this.quoteCheckoutService.checkSubmission) {
      this.quoteCheckoutService.checkSubmission.next(false)
    }
  }
  getQuoteCart() {
    this.quoteService.getCart(undefined, this.userType).subscribe(
      (cart) => {
        if (this.userType === 'current') {
          this.cartId = cart['code']
        } else {
          this.cartId = cart['guid']
        }
        sessionStorage.setItem('cartStatus-' + this.userType, 'empty')
        sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        sessionStorage.setItem('cartStatus-' + this.userType, 'empty')
        sessionStorage.setItem(
          'quoteCart-requestedDate',
          new Date().toISOString()
        )
      },
      (error) => {
        if (error.status === 400) {
          this.cartId = undefined
          this.getQuoteCart()
        }
      }
    )
  }
  showComplienceQuestions() {
    var showCount = 0
    this.legalEntityData?.forEach((element) => {
      if (
        element.code == this.cartData?.legalEntity &&
        element.salesAreaAddress?.country?.isocode ==
          this.cartData?.endUserAddress?.country?.isocode
      ) {
        showCount = showCount + 1
      } else {
      }
    })
    if (showCount > 0) {
      this.showComplienceQues = false
    } else {
      this.showComplienceQues = true
    }
  }

  routeForEditAddress() {
    this.router.navigate(['quote/checkout'])
  }

  routeForEditCart() {
    this.router.navigate(['quote/cart'])
  }

  gtmPurchaseEvent(code) {
    let producitem: EcommerceItem[] = [];

    this.cartData?.entries.forEach((item, i) => {
      let eachitem: EcommerceItem = {
        item_id: item?.product?.code,
        item_name: item?.product?.name,
        index: i,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: item?.netPrice?.value,
        quantity: item?.quantity || 1,
        lead_time: (item?.leadTime) ? item?.leadTime : ''
      };
      producitem.push(eachitem);
    });

    let purchaseEcommerceEcommerce: Ecommerce = {
      quote_id: code,
      value: this.cartData?.totalPrice.value,
      tax: this.cartData?.totalTax.value,
      currency: this.cartData?.totalPrice?.currencyIso,
      items: producitem,
    };
    let purchaseDataLayer: GTMDataLayer = {
      event: GtmEvents.Quote,
      ecommerce: purchaseEcommerceEcommerce,
      commerceType: GTMCartType.QUOTE_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(purchaseDataLayer);
  }
}
